import type { IExtractRouteParamMap, IRouteTranslation } from "../../types";
import { createBreadcrumbObject, createPaths, rebase } from "../../utils";

// Base route constant
const baseRoute = `/student-management`;

// * Route configuration object for student-related paths.
// ! This object is `readonly` to ensure route parameters are extracted properly.
export const studentRoutesObj = {
  list: baseRoute,
  create: `${baseRoute}/create`,
  view: `${baseRoute}/view/:studentId`,
  edit: `${baseRoute}/edit/:studentId`,
} as const;

// ! these are breadcrumbs translation not page title
const studentRouteTranslation: IRouteTranslation<typeof studentRoutesObj> = {
  list: "studentsManagement",
  create: "addStudent",
  edit: "editStudent",
  view: "viewStudent",
};

// * Extracts the route parameters for the student route configuration.
export type IStudentRouteParams = IExtractRouteParamMap<
  typeof studentRoutesObj
>;

// * Path functions for the student routes.
export const studentPath = createPaths<
  typeof studentRoutesObj,
  IStudentRouteParams
>(studentRoutesObj);

// * Breadcrumbs {translation and route} for the media routes
export const studentBreadcrumbs = createBreadcrumbObject<
  typeof studentRoutesObj
>(studentRoutesObj, studentRouteTranslation);
rebase(studentBreadcrumbs, "list");
